import { Component, inject, ChangeDetectionStrategy, effect } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AuthService } from '@mybitzer/core/auth/auth.service'
import { LanguageService } from '@mybitzer/core/language/language.service'
import { IconService } from '@mybitzer/shared/icon-registry/icon.service'
import { injectDocumentLang } from '@mybitzer/shared/util/language-utils'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  selector: 'boffice-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly languageService = inject(LanguageService)
  private readonly authService = inject(AuthService)
  private iconService = inject(IconService)

  title = 'mybitzer-backoffice'

  constructor() {
    injectDocumentLang()
    this.languageService.initLang('')
    effect(() => this.languageService.syncUserLang(this.authService.isLoggedIn()))
    this.iconService.registerIcons()
  }
}
